import { IWorkoutStatisticsPerWorkout } from "../models/workoutStatisticsViewModel";
import { shortDate } from "../utils/statisticsFormat";
import { ScrollableBarChart } from "./ScrollableBarChart";
import styles from "../WorkoutStatistics.module.scss";

interface ISetsRepsPerWorkoutChartProps {
  perWorkout: IWorkoutStatisticsPerWorkout[];
}

/** Grouped bars: sets and reps per workout across the period. */
export const SetsRepsPerWorkoutChart = ({
  perWorkout,
}: ISetsRepsPerWorkoutChartProps) => {
  const data = {
    labels: perWorkout.map((w) => shortDate(w.date)),
    datasets: [
      {
        label: "Серии",
        data: perWorkout.map((w) => w.sets),
        backgroundColor: "#5bd1c4",
        borderRadius: 6,
        maxBarThickness: 24,
      },
      {
        label: "Повторения",
        data: perWorkout.map((w) => w.reps),
        backgroundColor: "#ffb84d",
        borderRadius: 6,
        maxBarThickness: 24,
      },
    ],
  };

  return (
    <div className={styles.chart_card}>
      <h3 className={styles.chart_title}>Серии и повторения на тренировка</h3>
      <ScrollableBarChart
        data={data}
        count={perWorkout.length}
        slotWidth={60}
        showLegend
      />
    </div>
  );
};
